/* loaded by smart-asset */
export default require("./assets/package-csX.i.svg")